import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-terminal-name',
  templateUrl: './terminal-name.component.html',
  styleUrls: ['./terminal-name.component.scss'],
})
export class TerminalNameComponent implements OnInit {
  @Input()
  ledColor!: string;

  @Input()
  name!: string;

  color!: string;

  private red = '#f9430e';
  private green = '#0CCE6B';
  private grey = '#5d6c76';

  constructor() {}

  ngOnInit(): void {
    if (this.ledColor === 'red') {
      this.color = this.red;
    }
    if (this.ledColor === 'green') {
      this.color = this.green;
    }
    if (this.ledColor === 'grey') {
      this.color = this.grey;
    }
  }
}
